import { createClient } from "@supabase/supabase-js";

export const SUPABASE_URL = "https://auth.hojin.ai";
export const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNhamJ6d2hrbG92amtrZWdoYWx3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4MjAwNDgsImV4cCI6MjA5MzM5NjA0OH0.mkYv2wWlt_IOVqxSIU9F59QF06-zStg4D3zsWzc7wFk";

// Direct backend URL (server-side / debug). Le frontend passe par le proxy
// same-origin /__bk/* pour éviter les soucis CORS sur les domaines custom
// (hojin.ai, www.hojin.ai, futurs domaines…).
export const BACKEND_DIRECT_URL = "https://gargantua-production.up.railway.app";

// URL utilisée par le client (apiFetch + EventSource). Vide = same-origin.
// Les chemins "/api/..." sont réécrits en "/__bk/api/..." par apiFetch.
export const BACKEND_URL = "";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storageKey: "qorum.auth",
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
